import { NewOrderMachineProvider } from "machines/NewOrderMachine/newOrder.context";

const withNewOrderMachine = (Component) => (props) => {
  return (
    <NewOrderMachineProvider>
      <Component {...props} />
    </NewOrderMachineProvider>
  );
};

export default withNewOrderMachine;
